import Card from "../ui/Card";
import classes from './NewPostForm.module.css';
import {useRef} from 'react';

function NewPostForm(props){
    const titleInputRef = useRef();
    const imageInputRef = useRef();
    const addressInputRef = useRef();
    const descriptionInputRef = useRef();

    function submitHandler(event) {
        event.preventDefault();
        const enteredTitle = titleInputRef.current.value;
        const enteredImage = imageInputRef.current.value;
        const enteredAddress = addressInputRef.current.value;
        const enteredDescription = descriptionInputRef.current.value;

        const postData = {
            title: enteredTitle,
            image: enteredImage,
            address:enteredAddress,
            description:enteredDescription,

        };
        
        props.onAddPost(postData);


    }
    return <Card>
        <form className={classes.form} onSubmit={submitHandler}>
            <div className={classes.control}>
                <label htmlFor="title">Post Title</label>
                <input type="text" required id="title" ref={titleInputRef}/>
            </div>
            <div className={classes.control}>
                <label htmlFor="image">Post Image</label>
                <input type="url" required id="image" ref={imageInputRef}/>
            </div>
            <div className={classes.control}>
                <label htmlFor="address">Post Address</label>
                <input type="text" required id="address" ref={addressInputRef}/>
            </div>
            <div className={classes.control}>
                <label htmlFor="description">Description</label>
                <textarea  id="description" required rows='5' ref={descriptionInputRef}></textarea>
            </div>
            <div className={classes.action}>
                <button>Add New Post</button>
            </div>

        </form>
    </Card>
}
export default NewPostForm;